export default __webpack_public_path__ + "static/media/contactcard.d4ea8347.png";